var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#151e2d"},[React.createElement("path",{"d":"m15.45 17.4v-7.2754624s-.4125-1.52190795-1.875-1.44766853c-1.4625.07423941-1.95.29695764-2.625 1.07647147v7.64665946h-3.75v-11.50710889h3.75v1.70750648s1.2375-2.37566119 3.75-2.19006266c2.325.14847882 4.05 1.55902765 4.425 4.56572385h.075v7.42394122z","key":0}),React.createElement("path",{"d":"m1.8 3.6c-.99 0-1.8-.81-1.8-1.8s.81-1.8 1.8-1.8 1.8.81 1.8 1.8-.81 1.8-1.8 1.8z","key":1}),React.createElement("path",{"d":"m3.6 17.4h-3.6v-12h3.6z","key":2})]));
}

LinkedinIcon.defaultProps = {"height":"18","viewBox":"0 0 20 18","width":"20"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
